import {
  toast,
  type ToastContentProps,
  type ToastOptions,
} from 'react-toastify';

import { defaultToastConfig } from '@/common/config/toast';

import { SwipeableToast } from './SwipeableToast';

export const showToast = (
  text: string,
  picture?: { img: string; webp?: string },
  config: ToastOptions<unknown> = defaultToastConfig,
): void => {
  toast(
    ({ toastProps }: ToastContentProps) => (
      <SwipeableToast
        text={text}
        toastId={toastProps.toastId}
        picture={picture}
      />
    ),
    {
      ...config,
      className: `swipeable-toast !bg-transparent p-0 w-full !h-[3.5rem] !min-h-[3.5rem] px-4 mt-2 ${config.className || ''}`,
      closeButton: false,
      draggable: true,
      draggablePercent: 30,
    },
  );
};
